<div class="relative bg-cover bg-center bg-no-repeat text-white h-[500px] md:h-[800px] bg-gray-500 object-contain"
	[ngStyle]="{'background-image': 'url(' + tenant.getImg(tenant.HERO) + ')'}">

	<div class="flex items-center h-full">
		<div class="text-center mx-auto">
			<p class="text-3xl md:text-7xl md:leading-tight max-w-4xl font-semibold text-white mx-auto mb-6">
				The only phone plan built for {{ this.loadeddata?.ShortName === 'Bear' ? 'the' : '' }}
				{{this.loadeddata?.ShortName}} {{ this.loadeddata?.ShortName === 'Bear' ? 'Community' : 'Nation' }}
			</p>
			<div class="text-sm md:text-4xl md:mb-12 text-[#FAFAFA]">
				{{this.loadeddata?.Name}} contributes to {{ this.loadeddata?.ShortName === 'Bear' ? 'Cal Athletics' :
				this.loadeddata?.CollegeNameAcronym}} every time you pay your
				bill.
			</div>
			<div class="font-bold md:mb-24 mt-4 md:text-2xl md:text-5xl">On the T-Mobile 5G Network.</div>
			<a class="btn btn-white text-2xl bg-white font-bold rounded rounded-xl px-8 mt-6"
				[routerLink]="['/', this.tenant.getName(), 'landingpage']" fragment="ourPlansAnchor"
				[ngStyle]="{ color: loadeddata?.PrimaryColor }">Shop Plans</a>
		</div>
	</div>
</div>

<section class="husky-purple-bg py-4 px-4" id="ourPlans" #planssection
	[style.background-color]="this.loadeddata?.PrimaryColor">
	<div class="text-center">
		<img src="{{ tenant.getImg(tenant.MARK1) }}" class="object-cover m-auto"
			alt="Partner of {{ this.loadeddata?.CollegeName }}" title="Partner of {{ this.loadeddata?.CollegeName }}">
	</div>
</section>

<section class="mt-20">
	<div class="text-center mx-auto md:px-24">
		<h1 class="perk-header text-6xl font-bold">Why {{this.loadeddata?.Name}}?</h1>
		<div class="text-gray-500 text-2xl md:p-6">Our Giveback Program, perks and plans are made just for you.</div>

		<div class="block md:hidden ">
			<div #carousel class="flex overflow-x-auto space-x-4 pb-4 snap-x snap-mandatory ">

				<div class="flex-shrink-0 w-screen items-center p-6 text-center snap-center">
					<div class="grid place-items-center w-28 h-28 rounded-full mx-auto"
						[ngStyle]="{'background-color': loadeddata?.SeconndaryColor }">
						<img src="/assets/shared/perk1.png" class="object-cover mb-4">
					</div>
					<h3 class="perk-title font-bold text-2xl md:text-md">Help Fund the
						{{this.loadeddata?.ShortNamePlural}}</h3>
					<p class="text-gray-600 perk-description text-lg md:text-sm text-gray-500">
						{{this.loadeddata?.Name}} gives to {{ this.loadeddata?.ShortName === 'Bear' ? 'Cal Athletics' :
						this.loadeddata?.CollegeNameAcronym}} with every bill
						payment.</p>
				</div>

				<div class="flex-shrink-0 w-screen items-center p-6  text-center snap-center">
					<div class="grid place-items-center w-28 h-28 rounded-full mx-auto"
						[ngStyle]="{'background-color': loadeddata?.SeconndaryColor }">
						<img src="/assets/shared/perk2.png" class="object-cover m-auto">
					</div>
					<h3 class="perk-title font-bold text-2xl md:text-md">VIP Perks & Giveaways</h3>
					<p class="text-gray-600 perk-description text-lg md:text-sm text-gray-500">Exclusive gameday access
						and experiences.</p>
				</div>

				<div class="flex-shrink-0 w-screen items-center p-6 text-center snap-center">
					<div class="grid place-items-center w-28 h-28 rounded-full mx-auto"
						[ngStyle]="{'background-color': loadeddata?.SeconndaryColor }">
						<img src="/assets/shared/perk4.png" class="object-cover m-auto">
					</div>
					<h3 class="perk-title font-bold text-2xl md:text-md">On the T-Mobile 5G Network</h3>
					<p class="text-gray-600 perk-description text-lg md:text-sm text-gray-500">Seamless coverage with
						coast-to-coast 5G.</p>
				</div>

				<div class="flex-shrink-0 w-screen items-center  p-6  text-center snap-center">
					<div class="grid place-items-center w-28 h-28 rounded-full mx-auto"
						[ngStyle]="{'background-color': loadeddata?.SeconndaryColor }">
						<img src="/assets/shared/perk3.png" class="object-cover m-auto">
					</div>
					<h3 class="perk-title font-bold text-2xl md:text-md">Unbeatable Value</h3>
					<p class="text-gray-600 perk-description text-lg md:text-sm text-gray-500">Plans start at $15, taxes
						and fees included.</p>
				</div>

				<div class="flex-shrink-0 w-screen items-center  p-6  text-center snap-center">
					<div class="grid place-items-center w-28 h-28 rounded-full mx-auto"
						[ngStyle]="{'background-color': loadeddata?.SeconndaryColor }">
						<img src="/assets/shared/perk5.png" class="object-cover m-auto">
					</div>
					<h3 class="perk-title font-bold text-2xl md:text-md">Switch Stress-Free</h3>
					<p class="text-gray-600 perk-description text-lg md:text-sm text-gray-500">Bring your phone, keep
						your number—no contract, no problem.</p>
				</div>
			</div>

			<!-- Dots  -->
			<div class="flex justify-center mt-4 space-x-2 mb-4">
				<button (click)="scrollToCard(0)" [ngClass]="getDotClass(0)"></button>
				<button (click)="scrollToCard(1)" [ngClass]="getDotClass(1)"></button>
				<button (click)="scrollToCard(2)" [ngClass]="getDotClass(2)"></button>
				<button (click)="scrollToCard(3)" [ngClass]="getDotClass(3)"></button>
				<button (click)="scrollToCard(4)" [ngClass]="getDotClass(4)"></button>
			</div>
		</div>

		<div class="hidden md:grid grid-cols-1 md:grid-cols-5 mt-2 mb-6">
			<div class="text-center m-6">
				<!-- <div class="icon-wrapper ">
				<span class="material-symbols-outlined perk-icon">receipt_long</span>
				</div> -->
				<div class="h-[120px] justify-center  mx-auto">
					<div class="grid place-items-center w-28 h-28 rounded-full mx-auto"
						[ngStyle]="{'background-color': loadeddata?.SeconndaryColor }">
						<img src="/assets/shared/perk1.png" class="object-cover m-auto mb-4">
					</div>
				</div>
				<h3 class="perk-title font-bold text-2xl md:text-3xl">Help Fund the {{this.loadeddata?.ShortNamePlural}}
				</h3>
				<p class="text-gray-600 perk-description text-lg md:text-md text-gray-500">{{this.loadeddata?.Name}}
					gives to {{ this.loadeddata?.ShortName === 'Bear' ? 'Cal Athletics' :
					this.loadeddata?.CollegeNameAcronym}} with every bill payment.</p>
			</div>

			<div class="text-center m-6">
				<!-- <div class="icon-wrapper ">
				<span class="material-symbols-outlined perk-icon">receipt_long</span>
				</div> -->
				<div class="h-[120px] justify-center  mx-auto">
					<div class="grid place-items-center w-28 h-28 rounded-full mx-auto"
						[ngStyle]="{'background-color': loadeddata?.SeconndaryColor }">
						<img src="/assets/shared/perk2.png" class="object-cover mx-auto ">
					</div>
				</div>
				<h3 class="perk-title font-bold text-2xl md:text-3xl">VIP Perks & Giveaways</h3>
				<p class="text-gray-600 perk-description text-lg md:text-md text-gray-500">Exclusive gameday access and
					experiences.</p>
			</div>

			<div class="text-center m-6">
				<!-- <div class="icon-wrapper ">
				<span class="material-symbols-outlined perk-icon">receipt_long</span>
				</div> -->
				<div class="h-[120px] justify-center  mx-auto">
					<div class="grid place-items-center w-28 h-28 rounded-full mx-auto"
						[ngStyle]="{'background-color': loadeddata?.SeconndaryColor }">
						<img src="/assets/shared/perk4.png" class="object-cover m-auto mb-4">
					</div>
				</div>
				<h3 class="perk-title font-bold text-2xl md:text-3xl">On the T-Mobile 5G Network</h3>
				<p class="text-gray-600 perk-description text-lg md:text-md text-gray-500">Seamless coverage with
					coast-to-coast 5G.</p>
			</div>

			<div class="text-center m-6">
				<!-- <div class="icon-wrapper ">
				<span class="material-symbols-outlined perk-icon">receipt_long</span>
				</div> -->
				<div class="h-[120px] justify-center  mx-auto">
					<div class="grid place-items-center w-28 h-28 rounded-full mx-auto"
						[ngStyle]="{'background-color': loadeddata?.SeconndaryColor }">
						<img src="/assets/shared/perk3.png" class="object-cover m-auto mb-4">
					</div>
				</div>
				<h3 class="perk-title font-bold text-2xl md:text-3xl">Unbeatable Value</h3>
				<p class="text-gray-600 perk-description text-lg md:text-md text-gray-500">Plans start at $15, taxes and
					fees included.</p>
			</div>

			<div class="text-center m-6">
				<!-- <div class="icon-wrapper ">
				<span class="material-symbols-outlined perk-icon">receipt_long</span>
				</div> -->
				<div class="h-[120px] justify-center  mx-auto">
					<div class="grid place-items-center w-28 h-28 rounded-full mx-auto"
						[ngStyle]="{'background-color': loadeddata?.SeconndaryColor }">
						<img src="/assets/shared/perk5.png" class="object-cover m-auto mb-4">
					</div>
				</div>
				<h3 class="perk-title font-bold text-2xl md:text-3xl">Switch Stress-Free</h3>
				<p class="text-gray-600 perk-description text-lg md:text-md text-gray-500">Bring your phone, keep you
					number—no contract, no problem.</p>
			</div>
		</div>
	</div>
</section>


<section class="pt-16 pb-2 px-2" [style.background-color]="this.loadeddata?.SeconndaryColor">
	<div class="text-center mb-8">
		<h3 class="text-lg font-semibold text-purple">HOW IT WORKS</h3>
		<h2 class="text-6xl mt-2 font-bold">Switching to {{this.loadeddata?.Name}} is Easy</h2>
		<p class="text-gray-500 mt-4 text-lg md:text-2xl">Bring your phone and we'll guide you step-by-step once you
			select a plan.</p>
	</div>

	<div class="block md:hidden w-full p-4">
		<!-- Mobile Step by Step-->
		<div #carousel1 class="flex overflow-x-auto   space-x-4 pb-4 snap-x snap-mandatory">

			<div class="flex-shrink-0 snap-center">
				<div class="w-[82vw]  bg-white p-4 snap-start   rounded-2xl shadow-lg">
					<div
						class="w-6 h-6 p-4 flex items-center justify-center husky-purple-bg rounded-full text-lg text-white font-bold">
						1</div>
					<h3 class="perk-title font-bold text-xl md:text-md pt-6 ">Check your Coverage</h3>
					<p class="text-gray-600 perk-description text-xl md:text-sm text-gray-500">Experience seamless
						coverage with coast-to-coast 5G.</p>
					<div class="text-xl md:text-sm text-purple mt-4"><a
							href="{{this.tenant.getName()}} 	/coveragemap">Check our coverage map</a></div>
				</div>
			</div>

			<div class="flex-shrink-0 snap-center">
				<div class="w-[82vw]  bg-white p-6 snap-start   rounded-2xl shadow-lg">
					<div
						class="w-6 h-6 p-4 flex items-center justify-center husky-purple-bg rounded-full text-lg text-white font-bold">
						2</div>
					<h3 class="perk-title font-bold text-2xl md:text-md pt-6">Pick your Plan</h3>
					<p class="text-gray-600 perk-description text-xl md:text-sm text-gray-500">Student, faculty, alum,
						or {{ this.loadeddata?.ShortName === 'Bear' ? this.loadeddata?.ShortNamePlural :
						this.loadeddata?.ShortName }} fan—
						just bring your phone and pick what works best for you.</p>
				</div>
			</div>

			<div class="flex-shrink-0 snap-center">
				<div class="w-[82vw] h-full bg-white p-6 snap-start   rounded-2xl shadow-lg">
					<div
						class="w-6 h-6 p-4 flex items-center justify-center husky-purple-bg rounded-full text-lg text-white font-bold">
						3</div>
					<h3 class="perk-title font-bold text-2xl md:text-md pt-6">Activate your Plan</h3>
					<p class="text-gray-600 perk-description text-xl md:text-sm text-gray-500">Bring your number or get
						a fresh one—it's up to you.</p>
				</div>
			</div>
		</div>

		<!-- Dots  -->
		<div class="flex justify-center mt-4 space-x-2">
			<button (click)="scrollToplansCard(0)" [ngClass]="getDotClassforplanscard(0)"></button>
			<button (click)="scrollToplansCard(1)" [ngClass]="getDotClassforplanscard(1)"></button>
			<button (click)="scrollToplansCard(2)" [ngClass]="getDotClassforplanscard(2)"></button>
		</div>
	</div>

	<div class="hidden md:grid md:p-6 md:grid-cols-3 gap-6 flex flex-col mx-auto max-w-[90%]">

		<!-- Desktop Step by Step-->
		<div class="bg-white p-10 rounded-2xl shadow-lg">
			<div
				class="w-16 h-16 flex items-center justify-center husky-purple-bg rounded-full text-4xl text-white font-bold">
				1</div>
			<h3 class="text-5xl font-semibold my-6">Check your<br> Coverage</h3>
			<p class="mt-2 text-2xl text-black">
				Experience seamless coverage with coast-to-coast 5G.
			</p>
			<div class="text-2xl text-purple mt-4"><a href="{{this.tenant.getName()}}/coveragemap">Check our coverage
					map</a></div>
		</div>

		<div class="bg-white p-10 rounded-2xl shadow-lg">
			<div
				class="w-16 h-16 flex items-center justify-center husky-purple-bg rounded-full text-4xl text-white font-bold">
				2</div>
			<h3 class="text-5xl font-semibold my-6">Pick your<br> Plan</h3>
			<p class="mt-2 text-2xl text-black">Student, faculty, alum, or {{ this.loadeddata?.ShortName === 'Bear' ?
				this.loadeddata?.ShortNamePlural : this.loadeddata?.ShortName }} fan—just bring your phone and pick what
				works best for you.</p>
		</div>

		<div class="bg-white p-10 rounded-2xl shadow-lg">
			<div
				class="w-16 h-16 flex items-center justify-center husky-purple-bg rounded-full text-4xl text-white font-bold">
				3</div>
			<h3 class="text-5xl font-semibold my-6">Activate your<br> Plan</h3>
			<p class="mt-2 text-2xl text-black">Bring your number or get a fresh one—it's up to you.</p>
		</div>
	</div>
</section>

<div id="ourPlansAnchor" class="relative -top-20"></div>

<section class="husky-purple-bg pt-10 pb-16" id="ourPlans" #planssection
	[style.background-color]="this.loadeddata?.PrimaryColor">

	<div class="text-center mb-8">
		<h3 class="text-lg font-semibold my-6 text-white">OUR PLANS</h3>
		<h2 class="p-6 text-6xl font-bold text-white">Select the Plan That Is Right for You.</h2>
		<p class="mt-6 mb-12 text-2xl text-white">On the T-Mobile 5G Network</p>
	</div>

	<div class="grid grid-cols-1 gap-8 max-w-[90%] mx-auto px-4 text-center justify-between" [ngClass]="{
    'md:grid-cols-3': facultyEnabled,
    'md:grid-cols-2': !facultyEnabled
  }">

		<div class="card bg-white rounded-2xl flex flex-col border-[8px]"
			[style.border-color]="this.loadeddata?.ThirdColor">
			<div class="card-body px-6 py-4 flex flex-col justify-between">
				<div>
					<h3 class="text-3xl font-bold mt-4">I'm an Alum or Fan</h3>
					<p class="pr-4 pl-4 text-2xl text-black text-center my-12">We contribute to
						{{ this.loadeddata?.ShortName === 'Bear' ? 'Cal Athletics' :
						this.loadeddata?.CollegeNameAcronym}} every time you pay your bill.</p>
				</div>
				<button class="btn btn-primary w-full text-sm md:text-lg mx-auto mt-4 border-0"
					(click)="exploreplan('Alumni')">See Fan Plan Details</button>
			</div>
		</div>

		<div class="card bg-white rounded-2xl  flex flex-col border-[8px]"
			[style.border-color]="this.loadeddata?.ThirdColor">
			<div class="card-body px-6 py-4 flex flex-col justify-between">
				<div>
					<h3 class="text-3xl font-bold mt-4">I'm a Student</h3>
					<p class="p-4 text-2xl text-black justify-center text-center my-12">Plans start at $15/month.</p>
				</div>
				<button class="btn btn-primary w-full text-sm md:text-lg mx-auto mt-4 border-0 "
					(click)="exploreplan('Student')">See Student Plan Details</button>
			</div>
		</div>

		<div *ngIf="facultyEnabled" class="card bg-white rounded-2xl flex flex-col border-[8px]"
			[style.border-color]="this.loadeddata?.ThirdColor">
			<div class="card-body px-6 py-4 flex flex-col justify-between">
				<div>
					<h3 class="text-3xl font-bold mt-4">I'm Faculty or Staff</h3>
					<p class="pr-4 pl-4 text-2xl text-black text-center my-12">20% off Fan plans.</p>
				</div>
				<button class="btn btn-primary w-full ext-sm md:text-lg mx-auto mt-4 border-0"
					(click)="exploreplan('Faculty')">See Faculty Plan Details</button>
			</div>
		</div>

	</div>
</section>


<div class="h-5 w-full" [style.background-color]="this.loadeddata?.ThirdColor"></div>

<div class="p-[20px] md:p-3 md:pl-16 md:pt-14 md:pb-[3rem] flex flex-col md:flex-row gap-8"
	[style.background-color]="this.loadeddata?.SeconndaryColor">
	<div class="md:w-1/2 md:p-10">
		<div class="md:max-w-[75%] md:ml-12">
			<h2 class=" text-6xl font-bold">More Than a Phone Plan</h2>
			<p class="mt-8 text-xl md:text-2xl text-black">
				Our mission is to unite the {{this.loadeddata?.ShortName}} {{ this.loadeddata?.ShortName === 'Bear' ?
				'Community' : 'Nation' }} with exclusive experiences that spark passion, connection, and lifelong pride.
			</p>
			<p class="mt-8 text-black text-xl md:text-2xl font-semibold">
				Stay connected wherever you go, on campus and beyond.
			</p>
		</div>
	</div>

	<!-- Right Section -->
	<div class="md:w-1/2 flex flex-col">
		<h3 class="text-2xl md:text-4xl font-bold mt-4">Built for {{ this.loadeddata?.ShortName === 'Bear' ? 'the' : ''
			}}
			{{this.loadeddata?.ShortName}} {{ this.loadeddata?.ShortName === 'Bear' ? 'Community' : 'Nation' }}</h3>
		<p class="text-black text-lg md:text-2xl my-4">We contribute to {{this.loadeddata?.ShortName === 'Bear' ? 'Cal
			Athletics' : this.loadeddata?.CollegeNameAcronym}} every
			time you pay your bill.</p>
		<hr class="h-px my-4 border-0" [ngStyle]="{'background-color': loadeddata?.PrimaryColor }">

		<h3 class="text-2xl md:text-4xl font-bold mt-4">Exclusive Stadium Perks</h3>
		<p class="text-black text-lg md:text-2xl my-4">VIP Perks, seat upgrades and premium giveaways.</p>
		<hr class="h-px my-4 border-0" [ngStyle]="{'background-color': loadeddata?.PrimaryColor }">

		<h3 class="text-2xl md:text-4xl font-bold mt-4">On the T-Mobile 5G Network</h3>
		<p class="text-black text-lg md:text-2xl my-4">Seamless coverage with coast-to-coast 5G.</p>
		<hr class="h-px my-4 border-0" [ngStyle]="{'background-color': loadeddata?.PrimaryColor }">

		<h3 class="text-2xl md:text-4xl font-bold mt-4">Affordable & Transparent Pricing</h3>
		<p class="text-black text-lg md:text-2xl my-4">Unlimited talk, text, and data at unbeatable value with no hidden
			fees.</p>
		<hr class="h-px my-4 border-0" [ngStyle]="{'background-color': loadeddata?.PrimaryColor }">

		<h3 class="text-2xl md:text-4xl font-bold mt-4">No Contracts, No Commitments</h3>
		<p class="text-black text-lg md:text-2xl my-4">Freedom to switch anytime.</p>
	</div>
</div>


<app-giveaways></app-giveaways>


<div id="supportAnchor" class="relative -top-20"></div>

<section class="mx-auto p-6 md:py-20 md:px-24">
	<div class="grid md:grid-cols-2">
		<div>
			<p class="text-lg md:text-lg  font-semibold tracking-wide mb-2"
				[ngStyle]="{ color: loadeddata?.PrimaryColor }">FREQUENTLY ASKED QUESTIONS</p>
			<h2 class="text-4xl md:text-6xl font-bold text-gray-900 mb-4">Have questions? <br class="hidden sm:inline">
				We've got answers.</h2>
			<div class="md:mt-8">
				<a class="btn btn-primary  border-0 text-center md:text-lg mb-6" target="_blank"
					rel="noopener noreferrer" (click)="trackclick('landingpage.seemorefaqs')"
					href="https://intercom.help/collegiate-mobile-help-center/en/collections/13603484-faqs">See more
					FAQs</a>
				<a class="btn btn-primary  border-0 ml-6 md:text-lg" target="_blank" rel="noopener noreferrer"
					(click)="trackclick('landingpage.visitsupport')" [href]="generalSupportURL">Visit Support</a>
			</div>
		</div>

		<div class="border-0 w-full md:pt-10 md:pt-0">
			<button class="w-full flex text-right" onclick="this.nextElementSibling.classList.toggle('hidden')"
				(click)="faqOpen.faq1 = !faqOpen.faq1; trackclick('landingpage.faq1expand')">
				<span class="text-xl pr-4 " [ngStyle]="{ color: loadeddata?.PrimaryColor }">{{ faqOpen.faq1 ? '−' : '+'
					}}</span> <!-- Plus sign on right -->
				<span class="text-2xl text-left " [ngStyle]="{ color: loadeddata?.PrimaryColor }">Why Choose
					{{this.loadeddata?.Name}}?</span>
			</button>
			<div class="hidden px-8 pb-4 text-black">
				<p class="mb-2">{{this.loadeddata?.Name}} is the only wireless service that gives back to
					{{ this.loadeddata?.ShortName === 'Bear' ? 'Cal' :
					this.loadeddata?.CollegeName + ' and ' + this.loadeddata?.ShortName }} Athletics when you pay your
					bill
					every month.</p>
				<p class="mb-2">When you switch to {{this.loadeddata?.Name}}, you get to decide whether our
					contributions help {{ this.loadeddata?.ShortName === 'Bear' ? 'Cal' :
					this.loadeddata?.CollegeNameAcronym }} recruit top talent, fund student
					scholarships, or strengthen student programs across campus and beyond. Add in exclusive game day
					perks and unforgettable {{this.loadeddata?.ShortName}} experiences, and you're not just a fan—you're
					part of the team.</p>
			</div>
			<hr class="h-px my-4 border-0" [ngStyle]="{'background-color': loadeddata?.PrimaryColor }">
			<button class="w-full flex text-right" onclick="this.nextElementSibling.classList.toggle('hidden')"
				(click)="faqOpen.faq2 = !faqOpen.faq2; trackclick('landingpage.faq2expand')">
				<span class="text-xl pr-4 " [ngStyle]="{ color: loadeddata?.PrimaryColor }">{{ faqOpen.faq2 ? '−' : '+'
					}}</span> <!-- Plus sign on right -->
				<span class="text-2xl text-left  " [ngStyle]="{ color: loadeddata?.PrimaryColor }">Who is Collegiate
					Mobile?</span>
			</button>
			<div class="hidden px-8 pb-4 text-black">
				<p>Our mission is to help America's colleges and universities foster deeper community engagement by
					connecting students, faculty, alumni, and fans in innovative, new ways. We do this by building high
					quality and affordable, school-branded wireless plans that allow customers to meaningfully engage
					with and support their favorite school athletic and academic programs. {{this.loadeddata?.Name}} is
					a product of the partnership between Collegiate Mobile, the {{this.loadeddata?.CollegeName}},
					T-Mobile, and sports marketing firm Learfield Communications.</p>
			</div>
			<hr class="h-px my-4 border-0" [ngStyle]="{'background-color': loadeddata?.PrimaryColor }">
			<button class="w-full flex text-right" onclick="this.nextElementSibling.classList.toggle('hidden')"
				(click)="faqOpen.faq3 = !faqOpen.faq3; trackclick('landingpage.faq3expand')">
				<span class="text-xl pr-4 " [ngStyle]="{ color: loadeddata?.PrimaryColor }">{{ faqOpen.faq3 ? '−' : '+'
					}}</span> <!-- Plus sign on right -->
				<span class="text-2xl text-left " [ngStyle]="{ color: loadeddata?.PrimaryColor }">What Perks Do I Get as
					a {{this.loadeddata?.Name}} Customer?</span>
			</button>
			<div class="hidden px-8 pb-4 text-black">When you join {{this.loadeddata?.Name}}, you're not just getting a
				phone plan—you're becoming part of something bigger. As a member of the
				{{this.loadeddata?.ShortName}} {{ this.loadeddata?.ShortName === 'Bear' ? 'Community' : 'Nation' }},
				you'll enjoy exclusive perks designed for {{this.loadeddata?.ShortNamePlural}} who want to stay
				connected to their roots:

				<p class="mb-4 mt-4"> <span class="font-bold"> Give Back: </span> {{this.loadeddata?.Name}} will
					automatically contribute to {{this.loadeddata?.ShortName === 'Bear' ? 'Cal Athletics' :
					this.loadeddata?.CollegeNameAcronym}} when you pay your bill each
					month. There's no extra cost, just extra money for the school you care about most. </p>

				<p class="mb-4">
					<span [innerHTML]="this.loadeddata?.FAQPerkText"></span>
				</p>
				<p class="mb-4"> <span class="font-bold">Free Premium Seats:</span> Level up your game day experience
					with free premium seat giveaways. {{ this.loadeddata?.Name }} customers can enter for a chance to
					win some of the
					best seats at {{ this.loadeddata?.StadiumName }} and other {{ this.loadeddata?.ShortName === 'Bear'
					? 'Cal' : this.loadeddata?.CollegeNameAcronym }} sporting events — no purchase required.</p>
				<p class="mb-4"> <span class="font-bold">Premium {{ this.loadeddata?.ShortName === 'Bear' ?
						this.loadeddata?.ShortNamePlural : this.loadeddata?.ShortName }}
						Giveaways:</span> Every
					{{this.loadeddata?.Name}} customer can register to win once-in-a-lifetime game day experiences,
					premium stadium access, {{ this.loadeddata?.ShortName === 'Bear' ?
					this.loadeddata?.ShortNamePlural : this.loadeddata?.ShortName }} swag, or other premium prizes.</p>
			</div>
			<hr class="h-px my-4 border-0" [ngStyle]="{'background-color': loadeddata?.PrimaryColor }">
			<button class="w-full flex text-right" onclick="this.nextElementSibling.classList.toggle('hidden')"
				(click)="faqOpen.faq4 = !faqOpen.faq4; trackclick('landingpage.faq4expand')">
				<span class="text-xl pr-4 " [ngStyle]="{ color: loadeddata?.PrimaryColor }">{{ faqOpen.faq4 ? '−' : '+'
					}}</span> <!-- Plus sign on right -->
				<span class="text-2xl text-left " [ngStyle]="{ color: loadeddata?.PrimaryColor }">Is
					{{this.loadeddata?.Name}} Only Available for {{this.loadeddata?.CollegeNameAcronym}} Students,
					Alumni, & Faculty?</span>
			</button>
			<div class="hidden px-8 pb-4 text-black">
				<p class="mb-2">{{this.loadeddata?.Name}} is available to all! You don't need to be a
					{{this.loadeddata?.CollegeNameAcronym}} student, alum or faculty member to activate wireless service
					plans with {{this.loadeddata?.Name}}. Whether you're a lifelong fan, a parent, or just love the
					{{this.loadeddata?.CollegeColors}}, you're welcome here.</p>
				<p class="mb-2">Explore our Alumni & Fan Plans to see the exclusive perks, nationwide coverage, and
					great value you can enjoy—all while helping support the {{this.loadeddata?.ShortName === 'Bear' ?
					this.loadeddata?.ShortName : this.loadeddata?.CollegeNameAcronym}}
					community.</p>
			</div>
			<hr class="h-px my-4 border-0" [ngStyle]="{'background-color': loadeddata?.PrimaryColor }">
		</div>
	</div>
</section>

<div class="divider"></div>